module.exports = __webpack_public_path__ + "img/buy_normal_id.59f54871.png";